import { Component, ChangeDetectionStrategy } from '@angular/core';
import { APP_VERSION } from '../../../lib/constants';
import { EvCookieBannerComponent } from '../../../lib/components/ev-cookie-banner.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-portale-layout-header',
    templateUrl: './portale-layout-header.component.html',
    styleUrls: ['./portale-layout-header.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [EvCookieBannerComponent, RouterLink]
})
export class PortaleLayoutHeaderComponent {

  APP_VERSION = APP_VERSION

  constructor() { }

}
